import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTreeModule } from '@angular/material/tree';
import { MatRadioModule } from '@angular/material/radio';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';

import { HeaderComponent } from './header/header.component';
import { ProjectcardComponent } from './projectcard/projectcard.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { StatusBarComponent } from './status-bar/status-bar.component';
import { CardBarComponent } from './card-bar/card-bar.component';
import { ProjectMenuComponent } from './project-menu/project-menu.component';
import { FavFilterComponent } from './filter/fav-filter/fav-filter.component';
import { MenuFilterComponent } from './filter/menu-filter/menu-filter.component';
import { SearchbarComponent } from './filter/searchbar/searchbar.component';
import { FormInputComponent } from './form-input/form-input.component';
import { LoaderComponent } from './loader/loader.component';
import { MenuComponent } from './menu/menu.component';
import { NotificationComponent } from './notification/notification.component';
import { RequestBarComponent } from './request-bar/request-bar.component';
import { ButtonComponent } from './button/button.component';
import { FormFieldComponent } from './form-field/form-field.component';
import { TableComponent } from './table/table.component';
import { ButtonIconComponent } from './button-icon/button-icon.component';
import { ProjectStepperComponent } from './project-stepper/project-stepper.component';
import { FilterMenuComponent } from './filter-menu/filter-menu.component';
import { VersionFilterComponent } from './version-filter/filter.component';
// import { ButtonIconComponent } from './button-icon/button-icon.component';
import { ExpansionPanelComponent } from './expansion-panel/expansion-panel.component';
import { TableCreditsComponent } from './table-credits/table-credits.component';
import { TreeviewComponent } from './treeview/treeview.component';
import { ResultsMenuComponent } from './results-menu/results-menu.component';
import { ImgBlobComponent } from './img-blob/img-blob.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { TooltipDirective } from './tooltip/tooltip.directive';
import { IconComponent } from './icon/icon.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { TabGroupComponent } from './tab-group/tab-group.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { SelectComponent } from './select/select.component';
import { InputComponent } from './input/input.component';
import { GenericChatComponent } from './chat/generic-chat.component';
import { MoldedChatComponent } from './chat/molded-chat.component';
import { ChipComponent } from './chip/chip.component';
import { SliderComponent } from './slider/slider.component';

import { ViewContainerRefService } from './table-credits/viewContainerRefService';
import { CdkDetailRowDirective } from './table-credits/cdk-detail-row.directive';

//import { DrawerComponent } from './drawer-compnent/drawer.component';

//3rd party libs
//import { PlotlyViaCDNModule } from 'angular-plotly.js';
import { PlotComponent } from './plot/plot.component';

import { FormatKeyPipe } from './format-key-pipe';
import { ChunkPipe } from './chunk-pip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonNavigateComponent } from './button-navigate/button-navigate.component';
import { RadioGroupComponent } from './radio-group/radio-group.component';
import { ToggleComponent } from './toggle/toggle.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';

// PlotlyViaCDNModule.setPlotlyVersion('latest');
// PlotlyViaCDNModule.setPlotlyBundle('basic');

import * as PlotlyJS from 'plotly.js-dist-min';
import { PlotlyModule } from 'angular-plotly.js';

PlotlyModule.plotlyjs = PlotlyJS;

@NgModule({
  declarations: [
    CardBarComponent,
    HeaderComponent,
    ProjectcardComponent,
    DropdownComponent,
    FavFilterComponent,
    MenuFilterComponent,
    SearchbarComponent,
    FormInputComponent,
    LoaderComponent,
    MenuComponent,
    NotificationComponent,
    ProjectMenuComponent,
    RequestBarComponent,
    StatusBarComponent,
    ButtonComponent,
    FormFieldComponent,
    TableComponent,
    ProjectStepperComponent,
    FilterMenuComponent,
    VersionFilterComponent,
    ButtonIconComponent,
    ExpansionPanelComponent,
    PlotComponent,
    TableCreditsComponent,
    CdkDetailRowDirective,
    TreeviewComponent,
    ResultsMenuComponent,
    ImgBlobComponent,
    TooltipComponent,
    TooltipDirective,
    IconComponent,
    ProgressBarComponent,
    ProgressSpinnerComponent,
    PaginatorComponent,
    //DrawerComponent,
    TabGroupComponent,
    CheckboxComponent,
    SelectComponent,
    InputComponent,
    GenericChatComponent,
    MoldedChatComponent,
    ButtonNavigateComponent,
    RadioGroupComponent,
    ToggleComponent,
    ChipComponent,
    SliderComponent,

    // pipes
    FormatKeyPipe,
    ChunkPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatBadgeModule,
    MatMenuModule,
    MatCardModule,
    MatOptionModule,
    MatInputModule,
    MatSelectModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    MatProgressBarModule,
    ScrollingModule,
    MatListModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatExpansionModule,
    MatListModule,
    MatTreeModule,
    MatRadioModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatChipsModule,
    MatSliderModule,
    // 3rd party
    PlotlyModule,
  ],
  exports: [
    HeaderComponent,
    ProjectcardComponent,
    DropdownComponent,
    StatusBarComponent,
    CardBarComponent,
    ProjectStepperComponent,
    TableComponent,
    FormFieldComponent,
    ButtonComponent,
    FilterMenuComponent,
    VersionFilterComponent,
    ButtonIconComponent,
    ExpansionPanelComponent,
    PlotComponent,
    LoaderComponent,
    TableCreditsComponent,
    FormInputComponent,
    LoaderComponent,
    NotificationComponent,
    TreeviewComponent,
    ResultsMenuComponent,
    ImgBlobComponent,
    TooltipComponent,
    TooltipDirective,
    IconComponent,
    ProgressBarComponent,
    ProgressSpinnerComponent,
    PaginatorComponent,
    //DrawerComponent,
    TabGroupComponent,
    CheckboxComponent,
    SelectComponent,
    InputComponent,
    GenericChatComponent,
    MoldedChatComponent,
    ButtonNavigateComponent,
    RadioGroupComponent,
    ToggleComponent,
    ChipComponent,
    SliderComponent,
  ],
  providers: [ViewContainerRefService],
})
export class UiSharedModule {}
